export default __webpack_public_path__ + "static/media/imageTum12.a7ead4c9.jpg";